<template>
  <v-card
    raised
    class="mb-1"
    :class="{ 'red lighten-4': errorUpload }"
  >
    <div class="d-flex align-center">
      <!--<editor-fold desc="Uploading loader">-->
      <v-progress-circular
        v-if="uploading"
        :indeterminate="true"
        :size="50"
        :width="3"
        class="ma-2"
        :value="file.progress"
      />
      <!--</editor-fold>-->

      <!--<editor-fold desc="Blob thumbnail">-->
      <v-img
        v-else-if="(file.thumb && file.thumb.length > 0)"
        :src="file.thumb"
        max-height="60px"
        max-width="60px"
        class="ma-2"
      />
      <!--</editor-fold>-->

      <!-- File icon if no image -->
      <v-icon
        v-else
        size="35"
        class="ma-2"
      >
        insert_drive_file
      </v-icon>

      <!-- File name -->
      <div class="flex-grow-1 px-2 overflow-hidden">
        <div
          class="text-truncate"
          style="max-width: 100%;"
          :title="fileName"
        >
          {{ fileName }}
        </div>
        <div
          v-if="uploading"
          class="caption"
        >
          Uploading: {{ file.progress }}%
        </div>
        <div
          v-else-if="errorUpload"
          class="caption red--text"
        >
          Upload failed
        </div>
      </div>

      <!-- Action buttons -->
      <div class="d-flex flex-column flex-shrink-0">
        <v-btn
          v-if="canRemove"
          text
          small
          class="ma-0"
          @click.native.stop="removeFile(file.id)"
        >
          <v-icon :color="errorUpload ? 'orange lighten-4' : 'red'">
            clear
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!uploading && errorUpload"
          text
          small
          class="ma-0"
          @click.native.stop="retryUpload"
        >
          <v-icon color="orange lighten-4">
            autorenew
          </v-icon>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SimpleFileCard',
    props: {
      file: {
        type: Object,
        default: () => ({})
      },
      canRemove: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      fileName() {
        // Get file name from different possible sources
        if (this.file.name) {
          return this.file.name
        } else if (this.file.response && this.file.response.name) {
          return this.file.response.name
        } else if (this.file.response && this.file.response.original_name) {
          return this.file.response.original_name
        } else if (this.file.file && this.file.file.name) {
          return this.file.file.name
        }
        return 'Unnamed file'
      },
      uploading() {
        return this.file.active && parseInt(this.file.progress) < 100
      },
      uploaded() {
        return this.file.success && parseInt(this.file.progress) === 100 && this.file.response.id
      },
      errorUpload() {
        return !this.file.success && !this.file.active
      },
      error() {
        return this.file.error
      }
    },
    methods: {
      ...mapActions(['previewImage', 'removeFile']),
      retryUpload() {
        // todo: retry upload this file
        // this.$parent.$refs.upload.active = true
      }
    }
  }
</script>
<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>
